import React, { useState, useEffect, useRef } from 'react';
import '../../../../scss/search.scss'; // Import CSS for styling
import searchIcon from '../../../../assets/images/search-icon.png';
import leftArrow from '../../../../assets/images/left-arrow.png';
import { fetchSearchResults } from './searchApis';
import {stripHtml} from './utilityMethods'
import moment from "moment";
import { getStartAndEndOfDayInUTC } from '../main-container/DateTimeUtils';
import SuggestionItem from './SuggestionItem';

const SearchPopup = ({ setSearchInput, setShowSearch, map, tenantId,placeholder, showCategories=false, timeZoneDiff, timeZone,eventStartDateData}) => {
  const [inputValue, setInputValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);  
  const [defaultSuggestions, setDefaultSuggestions] = useState([]);  
  const [categorySuggestions, setCategorySuggestions] = useState([]);  

  const [isExpanded, setIsExpanded] = useState(false);
  const [renderedCount, setRenderedCount] = useState(0);
  const chunkSize = 5;
  /**
    {
      "searchCategoryName1": {
        "categoryKeyNameInSearchData": "",
        "categoryKeyValueInSearchData": ""
      },
      "searchCategoryName2": {
        "categoryKeyNameInSearchData": "",
        "categoryKeyValueInSearchData": ""
      }
    }
   */
  const categories = ['Labs', 'Exhibitors', 'Sessions', 'Demos'];
  const categoriesKeys = {
  'Labs': ["labs"],
  'Exhibitors': ["exhibitor"],
  'Sessions': ["session"],
  'Demos': ["demos"]
};

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [expandedIndex, setExpandedIndex] = useState(null);

const toggleReadMore = (index) => {
  setExpandedIndex((prevIndex) =>
    prevIndex === index ? null : index  
  );
};

  const inputRef = useRef(null);
  useEffect(() => {
    const searchContainer = document.querySelector('.search-container');
    if (searchContainer) {
      if (suggestions.length > 0) {
        searchContainer.classList.add('with-suggestions');
      } else {
        searchContainer.classList.remove('with-suggestions');
      }
    }
  }, [suggestions]);

  useEffect(() => {
    inputRef.current.focus();
    showVirtualKeyboard();
  }, []);

  useEffect(() => {
    if (inputValue) {
      handleSearchSubmit(inputValue);
    } else {
      setRenderedCount(0);
      setSuggestions([]);
      // setFilteredSuggestions([]);
    }
  }, [inputValue]);

  const handleSearchSubmit = async (inputValue) => {
    setSearchInput(inputValue);

    const pointrWeb = map;
    const site = pointrWeb.getCurrentSite();
    const startEndEpochTimes = getStartAndEndOfDayInUTC(timeZone,eventStartDateData);
    console.log(startEndEpochTimes);
    const queryParams = {
      q: inputValue,
      ...(inputValue.startsWith("LAB") ? {} : { startEpochMilli: startEndEpochTimes.startEpochMilli, endEpochMilli: startEndEpochTimes.endEpochMilli })
    };
    const t1 = new Date().getTime();
   // console.log(t1);
    let searchResults = await fetchSearchResults(tenantId,  { q: inputValue, startEpochMilli: startEndEpochTimes.startEpochMilli, endEpochMilli: startEndEpochTimes.endEpochMilli });
   // setRenderedCount(0);
   // setDefaultSuggestions(sortedSessions); // store full list for category filtering, etc.
  
    const t2 = new Date().getTime();
    //console.log(("t2-t1 diff " + (t2 - t1)) );
    
    const t3= new Date().getTime();

    const matchedSessions = searchResults.filter((session) =>
      session.sessionCode?.toLowerCase() === inputValue?.toLowerCase()
    );

    searchResults=searchResults.map(item => ({
      ...item,
      name:getHighlightedText(item.name, inputValue),
      sessionName:getHighlightedText(item.sessionName, inputValue),
      ...(
        item.sessionType !== "labs"
          ? { formattedTime: convertSessionTime(item.utcStartTime) }
          : {}
      ),
      description:getHighlightedTextForSentence(stripHtml(item.description), inputValue),
      sessionCode:getHighlightedText(item?.sessionCode, inputValue),
      shouldApplyMask:shouldApplyMask(item),
      metadata:item.metadata?.join(', ')
    }))

    if(matchedSessions.length>0){
      matchedSessions?.sort((a, b) => a.utcStartTime - b.utcStartTime)
      const sortedSessions = [
        ...matchedSessions
       // ...searchResults.filter((session) => !session.sessionCode?.toLowerCase().includes(inputValue?.toLowerCase()))
      ];
      setSuggestions(searchResults);
      setDefaultSuggestions(searchResults);
    }else{
        setSuggestions(searchResults);
        setDefaultSuggestions(searchResults);
    }
  
    const t4= new Date().getTime();
   // console.log(("t4-t3 diff " + (t4 - t3)) );
    if(showCategories)
      {
       // setSuggestions(sortedSessions);
        let groupedByType = searchResults.reduce((map, item) => {
          const key = item.type === 'session' ? (item.sessionType?item.sessionType:item.type ): item.type;
          (map[key] = map[key] || []).push(item);
          return map;
        }, {});
        //console.log(groupedByType);
        for (const key in groupedByType) {
          groupedByType[key].sort((a, b) => a.utcStartTime - b.utcStartTime);
        }

        if (Object.keys(groupedByType).length > 0){
          setCategorySuggestions(groupedByType)
        }else{
          setCategorySuggestions(suggestions)
        }
        
        setSelectedCategory(null)
      }
      const t5= new Date().getTime();
    //  console.log(("t5-t4 diff " + (t5 - t4)));
  };

  const handleClosePopup = () => {
    setShowSearch(false);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      //handleSearchSubmit();
    }
  };

  const handleIconClick = () => {
    handleSearchSubmit();
  };

  const handleSuggestionClick = (suggestion) => {
    setSearchInput(suggestion); 
    setInputValue(suggestion);
    setShowSearch(false); 
  };

   const getHighlightedText = (text, highlight) => {
    if (!highlight) return text;
    const parts = text?.split(new RegExp(`(${highlight})`, 'gi'));
    return parts?.map((part, index) =>
      part.toLowerCase() === highlight.toLowerCase() ? (
        <span key={index} className="highlighted-text">{part}</span>
      ) : (
        part
      )
    );
  };

  const getHighlightedTextForSentence = (text, highlight) => {
    if (!highlight) return text;
    
     const escapedHighlight = highlight?.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    
     const parts = text?.split(new RegExp(`(${escapedHighlight})`, 'gi'));
    
    return parts?.map((part, index) =>
      part?.toLowerCase() === highlight?.toLowerCase() ? (
        <span key={index} className="highlighted-text">{part}</span>
      ) : (
        part
      )
    );
  };

  const handleCategoriesClick = (cat) =>{
    if(!cat||categorySuggestions[categoriesKeys[cat][0]]?.length<=0||categorySuggestions[categoriesKeys[cat][0]]===undefined){
      setSuggestions(defaultSuggestions)
      setSelectedCategory(null)
      return
    }
    setSuggestions(categorySuggestions[categoriesKeys[cat][0]])
  }

  const handleClearClick = () => {
    setInputValue('');
    setSearchInput('');
    setSuggestions([]);
    setSelectedCategory(null);
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const showVirtualKeyboard = () => {
    inputRef.current.focus();  
  };

  const shouldApplyMask = (suggestion) => {
    return (
      (suggestion.metadata && suggestion.metadata.length > 10) ||
      (suggestion.description && suggestion.description.length > 20)
    );
  };

  const convertSessionTime = (utcStartTime) => {
    if (!utcStartTime) return null;

    let formattedDate = moment.utc(utcStartTime); // Always start from UTC

    if (timeZoneDiff<0) {
      formattedDate = moment.utc(utcStartTime).subtract(Math.abs(timeZoneDiff),"hours"); // Apply the timezone if provided
    }else{
      formattedDate = moment.utc(utcStartTime).add(Math.abs(timeZoneDiff),"hours"); // Apply the timezone if provided
    }

    formattedDate = formattedDate.format("Do MMM, YYYY h:mm A");
    //console.log(formattedDate);
    // Output: "13th Feb, 2025 4:30 PM"
    return formattedDate
  }



  useEffect(() => {
    if (renderedCount < suggestions.length) {
      const id = setTimeout(() => setRenderedCount((c) => Math.min(c + chunkSize, suggestions.length)), 20);
      return () => {
        clearTimeout(id);
      };
    }
  }, [renderedCount, suggestions.length]);
  return (
    <div className="search-popup-overlay">
      <div className='search-container'>
        <div className="search-container-search-popup">
          <div className="search-container-search-popup-search-input">
            <div className="search-container-search-popup-search-input-container">
              <img
                src={searchIcon}
                alt="Search"
                className="search-container-search-popup-search-input-container-search-icon"
              />
              <input
                ref={inputRef}
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                placeholder={placeholder ? placeholder:"Search for zones, booths, hub walks and other facilities"}
              />
              {inputValue && (
                <span className="clear-text" onClick={handleClearClick}>
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.17229 11.3329L0.157501 18.3477L3.6649 21.8551L10.6797 14.8403L17.6945 21.8551L21.2019 18.3477L14.1871 11.3329L21.2019 4.31809L17.6945 0.81069L10.6797 7.82548L3.6649 0.810689L0.157502 4.31808L7.17229 11.3329Z" fill="white" />
                  </svg>

                </span>
              )}
            </div>
            <div className="search-container-search-popup-search-input-clear-text" onClick={handleClosePopup}>
              Cancel
            </div>
          </div>
          {suggestions.length > 0 && (
            <div className={`search-container-suggestions-list ${suggestions.length > 0 ? 'visible' : ''}`}
            >
             {showCategories &&  <div className="search-container-suggestions-list-categories">
                {categories.map(cat => (
                  <div
                    key={cat}
                    onClick={() => {setSelectedCategory(cat === selectedCategory ? null : cat);handleCategoriesClick(cat === selectedCategory ? null : cat)}}
                    className={`search-container-suggestions-list-categories-item${selectedCategory === cat
                        ? '-active'
                        : ''
                      }`}
                  >
                    <div className={`search-container-suggestions-list-categories-item-name${selectedCategory === cat
                        ? '-active'
                        : ''
                      }`}>
                    {cat}
                    </div>
                    <div className={`search-container-suggestions-list-categories-item-count${selectedCategory === cat
                        ? '-active'
                        : ''
                      }`}>
                     {categorySuggestions[categoriesKeys[cat][0]]?.length>0?categorySuggestions[categoriesKeys[cat][0]].length:0}  
                    </div>
                  </div>
                ))}
                <div className='search-container-suggestions-list-categories-clear-text'
                onClick={() => {handleCategoriesClick(null)}}>
                Clear Filters
                </div>
              </div>}
              <div className='search-container-suggestions-list-results-count'>{suggestions.length} results found</div>
              <div>
      {suggestions.slice(0, renderedCount).map((suggestion, index) => (
        <SuggestionItem
          key={index}
          suggestion={suggestion}
          index={index}
          expandedIndex={expandedIndex}
          handleSuggestionClick={handleSuggestionClick}
          toggleReadMore={toggleReadMore}
        />
      ))}
    </div>
            </div>)}
        </div>

      </div>
    </div>
  );
};

export default SearchPopup;
